var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { OnboardingLayout } from '../elements/onboarding-layout';
import { useLang } from '../hooks/use-lang';
import { useSite } from '../hooks/use-site';
import { SiteTermsPrivacyContent } from '../entities/site-terms-privacy-content';
import { OnboardingHeader } from '../elements/onboarding-header';
import { ContentNode } from '../entities/content-node';
import { compact } from 'lodash';
import { OnboardingButton } from '../elements/onboarding-button';
import { OnboardingSteps } from '../elements/onboarding-steps';
var cls = classNames('app-route-welcome');
export var AppRouteWelcomeDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TermsAndPrivacyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 35vh;\n    overflow: auto;\n    width: 100%;\n    padding: ", ";\n    max-width: 800px;\n    margin: 0 auto;\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    box-sizing: border-box;\n  "], ["\n    height: 35vh;\n    overflow: auto;\n    width: 100%;\n    padding: ", ";\n    max-width: 800px;\n    margin: 0 auto;\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    box-sizing: border-box;\n  "])), theme.UNIT(4), theme.COLOR('canvas'), theme.COLOR('line-subtle'), theme.UNIT(1)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme.UNIT(5)),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme.UNIT(6))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var WelcomeMessageStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AcceptanceMessageStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AcceptLoginButtonStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'AppRouteWelcome',
  Container: styled(OnboardingLayout)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(OnboardingHeader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  WelcomeMessage: styled(ContentNode)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), WelcomeMessageStyles),
  AcceptLoginButton: styled(OnboardingButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), AcceptLoginButtonStyles),
  AcceptanceMessage: styled(ContentNode)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), AcceptanceMessageStyles),
  TermsAndPrivacy: styled(SiteTermsPrivacyContent)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TermsAndPrivacyStyles)
};
export var AppRouteWelcome = function (props) {
  var componentProps = useComponentProps(My.NAME, AppRouteWelcomeDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    verify = componentProps.verify;
  var _a = __read(React.useState(false), 2),
    userHasAccepted = _a[0],
    setUserHasAccepted = _a[1];
  // const auth = useAuth();
  var site = useSite();
  var _b = site.welcomeTitle,
    welcomeTitle = _b === void 0 ? 'Welcome and thanks for joining us!' : _b,
    termsAndConditions = site.termsAndConditions,
    privacyPolicy = site.privacyPolicy;
  var t = useLang();
  var hasTerms = termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.text;
  var hasPrivacyPolicy = privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.text;
  var reviewItems = compact([hasTerms && 'Terms and Conditions', hasPrivacyPolicy && 'Privacy Policy']).join(' & ');
  var welcomeMessage = {
    text: "We're excited to have you as part of our community. Please take a moment to review our ".concat(reviewItems, ":")
  };
  var acceptanceMessage = {
    text: "By clicking 'Accept Invitation & Continue', you agree to the ".concat(reviewItems, " above.")
  };
  return userHasAccepted ? React.createElement(OnboardingSteps, {
    verify: verify
  }) : React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Header, {
    title: welcomeTitle
  }, React.createElement(My.WelcomeMessage, {
    entity: welcomeMessage
  })), React.createElement(My.TermsAndPrivacy, null), React.createElement(My.AcceptLoginButton, {
    onClick: function () {
      return setUserHasAccepted(true);
    }
  }, t("Accept Invitation & Continue")), React.createElement(My.AcceptanceMessage, {
    entity: acceptanceMessage
  }));
};
AppRouteWelcome.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;